import React from 'react'
import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts'

import { CustomAxisTick } from '@application/Interfaces/Features/Graph/CustomAxisTick'
import { useOrganization } from '@src/Application/Interfaces/Hooks/useOrganization/useOrganization'
import { GraphLineType, ThemeModeType } from '@src/Application/Types/ComponentTypes'

import { dateFormatter } from '../utils'
import { CustomTooltip } from './CustomTooltip'
import { getYAxisProps } from './utils'

const Layout: Record<ThemeModeType, Record<string, string>> = {
    Light: {
        lineColor: 'p500',
        axisColor: 'g500',
        gridColor: 'g200',
    },
    Dark: {
        lineColor: 'a600',
        axisColor: 'white',
        gridColor: 'p500',
    },
}

export type GraphPropsType = GraphLineType & {
    height: number
}

export const Graph = ({
    graphData,
    mode,
    height,
    legendDescription,
    domainValueMin,
    domainValueMax,
}: GraphPropsType): JSX.Element => {
    const { theme } = useOrganization()

    const gridColorCode = Layout[mode].gridColor
    const gridColor = theme.color[gridColorCode]

    const axisColorCode = Layout[mode].axisColor
    const axisColor = theme.color[axisColorCode]

    const lineColorCode = Layout[mode].lineColor
    const lineColor = theme.color[lineColorCode]

    return (
        <ResponsiveContainer width="100%" height={height}>
            <LineChart data={graphData}>
                <CartesianGrid stroke={gridColor} />
                <XAxis
                    dataKey="label"
                    tickFormatter={dateFormatter}
                    interval={0}
                    tick={<CustomAxisTick color={axisColor} />}
                    height={70}
                />
                <Legend />
                <YAxis type="number" tick={{ fill: axisColor }} {...getYAxisProps(domainValueMin, domainValueMax)} />
                <Tooltip content={<CustomTooltip />} wrapperStyle={{ outline: 'none' }} />
                <Line
                    type="monotone"
                    dataKey="value"
                    stroke={lineColor}
                    strokeWidth={3}
                    name={legendDescription as string}
                />
            </LineChart>
        </ResponsiveContainer>
    )
}
